import type { RouteLocationNormalized } from 'vue-router';

export const createStepGuard =
  (validSteps: readonly string[], fallback: string) =>
  (_to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    if (validSteps.includes(from.name as string)) {
      return true;
    }
    return { name: fallback };
  };
